export const getSortOptions = () => [
  {
    label: 'Most available',
    value: 'asc',
  },
  {
    label: 'Least available',
    value: 'desc',
  },
]
